// import { MessageSquare } from 'lucide-react'
// import React from 'react'

// const Allinclusive = () => {


//     const features = [
//     { icon: "🗄️", title: 'Cabinets', description: 'Premium quality cabinets custom-built to your specifications' },
//     { icon: "🪨", title: 'Countertops', description: 'Durable and beautiful countertop installation' },
//     { icon: "🧱", title: 'Backsplash', description: 'Professional backsplash design and installation' },
//     { icon: "🎨", title: 'Paint', description: 'Complete painting services for your kitchen' },
//     { icon: "🚰", title: 'Sink', description: 'High-quality sink installation with plumbing' },
//     { icon: "🔩", title: 'Hardware', description: 'Knobs, pulls, and all finishing hardware' },
//     { icon: "⚡", title: 'Electrical', description: 'Any necessary electrical work included' },
//     { icon: "👷", title: 'Complete Labor', description: 'Full installation from start to finish' }
//   ];

//   return (
//     <section className="py-12 sm:py-16 md:py-20 px-4 sm:px-6 lg:px-8" style={{ background: "var(--gradient-bg)" }}>
//             <div className="max-w-7xl mx-auto">
//               {/* Section Header */}
//               <div className="text-center mb-8 sm:mb-12">
//                 <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-6"
//                   style={{
//                     background: "var(--bg-primary-10)",
//                     border: "1px solid var(--border-primary-20)",
//                   }}
//                 >
//                   <MessageSquare size={14} style={{ color: "var(--color-primary-400)" }} />
//                   <span className="text-sm font-medium" style={{ color: "var(--color-primary-400)" }}>
//                     Complete Package Zero Stress.
//                   </span>
//                 </div>
                
//                 <h2 className="bell-mt-primary text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-3 sm:mb-4" style={{ color: "var(--color-primary-500)" }}>
//                   All-Inclusive Kitchen Transformation
//                 </h2>
                
//                 <p className="inter-secondary text-base sm:text-lg max-w-3xl mx-auto px-4" style={{ color: "var(--color-gray-600)" }}>
//                   Everything you need for a complete kitchen renovation, handled by our expert team from start to finish.
//                 </p>
    
//                 {/* Decorative Line */}
//                 <div className="flex justify-center mt-6" aria-hidden="true">
//                   <div 
//                     className="w-24 h-1 rounded-full"
//                     style={{
//                       background: "var(--gradient-primary)",
//                     }}
//                   ></div>
//                 </div>
//               </div>
    
//               <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-8 sm:mb-12 px-2 sm:px-0">
//                 {features.map((feature, index) => (
//                   <div
//                     key={index}
//                     className="group bg-white p-4 sm:p-6 rounded-xl sm:rounded-2xl border transition-all duration-300 hover:shadow-lg hover:-translate-y-1"
//                     style={{
//                       backgroundColor: "var(--color-white)",
//                       borderColor: "var(--border-light)",
//                       boxShadow: "var(--shadow-medium)",
//                     }}
//                   >
//                     {/* Icon and Title - Inline */}
//                     <div className="flex items-center gap-3 mb-3">
//                       {/* Icon Container */}
//                       <div
//                         className="w-12 h-12 sm:w-14 sm:h-14 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform"
//                         style={{
//                           backgroundColor: "var(--color-primary-500)",
//                         }}
//                       >
//                         <span
//                           className="text-2xl sm:text-3xl"
//                           style={{ color: "var(--color-primary-600)" }}
//                         >
//                           {feature.icon}
//                         </span>
//                       </div>
    
//                       {/* Title */}
//                       <h3
//                         className="bell-mt-primary text-base sm:text-lg font-semibold"
//                         style={{ color: "var(--color-primary-500)" }}
//                       >
//                         {feature.title}
//                       </h3>
//                     </div>
    
//                     {/* Description */}
//                     <p className="inter-secondary text-xs sm:text-sm" style={{ color: "var(--color-gray-600)" }}>
//                       {feature.description}
//                     </p>
//                   </div>
//                 ))}
//               </div>
    
//               <div 
//                 className="rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-10 text-center relative overflow-hidden"
//                 style={{
//                   background: "var(--gradient-primary)",
//                 }}
//               >
//                 {/* Background Decorative Elements */}
//                 <div 
//                   className="absolute top-0 left-0 w-32 h-32 sm:w-48 sm:h-48 md:w-64 md:h-64 rounded-full -translate-x-1/2 -translate-y-1/2 opacity-20 blur-3xl" 
//                   aria-hidden="true"
//                   style={{
//                     backgroundColor: "var(--color-white)",
//                   }}
//                 ></div>
//                 <div 
//                   className="absolute bottom-0 right-0 w-32 h-32 sm:w-48 sm:h-48 md:w-64 md:h-64 rounded-full translate-x-1/2 translate-y-1/2 opacity-20 blur-3xl" 
//                   aria-hidden="true"
//                   style={{
//                     backgroundColor: "var(--color-white)",
//                   }}
//                 ></div>
    
//                 <div className="relative z-10 max-w-4xl mx-auto">
//                   <h3 className="bell-mt-primary text-xl sm:text-2xl md:text-3xl font-bold mb-3 sm:mb-4" style={{ color: "var(--color-white)" }}>
//                     Complete Package. Zero Stress.
//                   </h3>
//                   <p className="inter-secondary text-sm sm:text-base md:text-lg mb-4 sm:mb-6 px-2" style={{ color: "rgba(255, 255, 255, 0.9)" }}>
//                     Our all-inclusive service includes cabinets, countertops, backsplash, paint, sink, 
//                     knobs and all materials needed to finish your kitchen. We handle the entire labor 
//                     to install kitchen, countertops, backsplash, any electric and plumbing work.
//                   </p>
//                   <div className="flex flex-wrap justify-center gap-2 sm:gap-3 md:gap-4">
//                     {["No Hidden Costs", "Single Point of Contact", "Guaranteed Timeline"].map((text, i) => (
//                       <div 
//                         key={i}
//                         className="backdrop-blur-sm px-3 py-1 sm:px-4 sm:py-2 rounded-full text-xs sm:text-sm"
//                         style={{
//                           backgroundColor: "var(--bg-white-10)",
//                           border: "1px solid var(--border-white-10)",
//                         }}
//                       >
//                         <span className="font-semibold" style={{ color: "var(--color-white)" }}>{text}</span>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </section>
//   )
// }

// export default Allinclusive


import React from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { 
  MessageSquare,
  CheckCircle,
  Clock,
  Shield,
  ArrowRight
} from 'lucide-react'

const Allinclusive = () => {
  const features = [
    { icon: "🗄️", title: 'Custom Kitchen Cabinets', description: 'Premium quality cabinets custom-built to your specifications with soft-close hinges and durable finishes. Available in 500+ colors and multiple styles including shaker, modern, and traditional.' },
    { icon: "🪨", title: 'Premium Countertops', description: 'Durable and beautiful countertop installation featuring quartz, granite, marble, and solid surface options. Professional templating and seamless installation included.' },
    { icon: "🧱", title: 'Custom Backsplash', description: 'Professional backsplash design and installation using ceramic, porcelain, glass, or natural stone tiles. Perfect complement to your new kitchen cabinets.' },
    { icon: "🎨", title: 'Complete Painting Services', description: 'Complete painting services for your kitchen including cabinet painting, wall painting, and trim work. Premium paints and flawless finish guaranteed.' },
    { icon: "🚰", title: 'Premium Sink & Faucet', description: 'High-quality sink installation with professional plumbing connections. Options include undermount, farmhouse, workstation sinks, and touchless faucets.' },
    { icon: "🔩", title: 'Cabinet Hardware', description: 'Knobs, pulls, and all finishing hardware professionally installed. Choose from premium brands with soft-close mechanisms and custom finishes.' },
    { icon: "⚡", title: 'Electrical Services', description: 'Any necessary electrical work included including outlet relocation, under-cabinet lighting, and pendant light installation. Licensed electricians ensure code compliance.' },
    { icon: "👷", title: 'Complete Labor', description: 'Full installation from start to finish including demolition, preparation, installation, and cleanup. Certified installers with years of experience.' }
  ]

  const benefits = [
    { icon: Shield, text: "Licensed & Insured", description: "Fully licensed and insured for your peace of mind" },
    { icon: Clock, text: "On-Time Delivery", description: "We respect your time and deadlines" },
    { icon: CheckCircle, text: "100% Satisfaction", description: "Quality guaranteed on every project" }
  ]

  // Schema data for SEO
  const serviceSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "Kitchen Renovation and Custom Cabinet Installation",
    "name": "All-Inclusive Kitchen Transformation Package",
    "description": "Complete kitchen renovation services including custom cabinets, countertops, backsplash, painting, sink installation, hardware, electrical work, and full labor. Premium quality installation and free consultation in New Jersey.",
    "provider": {
      "@type": "Organization",
      "name": "Laminance Cabinetry",
      "url": "https://laminance.com",
      "telephone": "+18624506069",
      "logo": "https://laminance.com/assets/Images/logo.png"
    },
    "areaServed": {
      "@type": "State",
      "name": "New Jersey"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Kitchen Renovation Services",
      "itemListElement": features.map((feature, index) => ({
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": feature.title,
          "description": feature.description
        },
        "position": index + 1
      }))
    },
    "termsOfService": "All-inclusive package with no hidden costs, single point of contact, and guaranteed timeline.",
    "priceSpecification": {
      "@type": "PriceSpecification",
      "price": "Custom Quote",
      "priceCurrency": "USD"
    }
  }

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "HomeAndConstructionBusiness",
    "name": "Laminance Cabinetry",
    "description": "Premier custom kitchen cabinet and complete kitchen renovation services in New Jersey. Specializing in acrylic cabinets, custom cabinetry, and all-inclusive kitchen transformations.",
    "url": "https://laminance.com",
    "telephone": "+18624506069",
    "email": "contactus@laminance.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "418 Rt 23",
      "addressLocality": "Franklin",
      "addressRegion": "NJ",
      "postalCode": "07416",
      "addressCountry": "US"
    },
    "priceRange": "$$",
    "openingHours": "Mo-Fr 09:00-18:00"
  }

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://laminance.com"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "All-Inclusive Kitchen Transformation",
        "item": "https://laminance.com/all-inclusive-kitchen-renovation"
      }
    ]
  }

  return (
    <>
      <Helmet>
        {/* Primary Meta Tags */}
        <title>All-Inclusive Kitchen Transformation | Custom Cabinets & Full Renovation | Laminance Cabinetry</title>
        <meta name="title" content="All-Inclusive Kitchen Transformation | Custom Cabinets & Full Renovation | Laminance Cabinetry" />
        <meta name="description" content="Complete all-inclusive kitchen transformation package including custom cabinets, countertops, backsplash, painting, sink, hardware, electrical, and full labor. Free consultation in New Jersey. Premium quality guaranteed!" />
        <meta name="keywords" content="all-inclusive kitchen renovation, custom kitchen cabinets, kitchen transformation package, complete kitchen remodel, cabinet installation New Jersey, Laminance Cabinetry" />
        <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large" />
        
        {/* Canonical URL */}
        <link rel="canonical" href="https://laminance.com/all-inclusive-kitchen-renovation" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://laminance.com/all-inclusive-kitchen-renovation" />
        <meta property="og:title" content="All-Inclusive Kitchen Transformation | Laminance Cabinetry" />
        <meta property="og:description" content="Complete kitchen transformation with premium quality custom cabinets, countertops, backsplash, and full labor. Free consultation in New Jersey." />
        <meta property="og:image" content="https://laminance.com/assets/Images/logo.png" />
        <meta property="og:image:alt" content="Laminance Cabinetry all-inclusive kitchen transformation showcase" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:site_name" content="Laminance Cabinetry" />
        <meta property="og:locale" content="en_US" />
        
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://laminance.com/all-inclusive-kitchen-renovation" />
        <meta name="twitter:title" content="All-Inclusive Kitchen Transformation | Laminance Cabinetry" />
        <meta name="twitter:description" content="Complete kitchen transformation with premium quality cabinets. Free consultation in New Jersey." />
        <meta name="twitter:image" content="https://laminance.com/assets/Images/logo.png" />
        <meta name="twitter:image:alt" content="Laminance Cabinetry kitchen transformation package" />
        <meta name="twitter:site" content="@laminance" />
        
        {/* Geo Meta Tags for Local SEO */}
        <meta name="geo.region" content="US-NJ" />
        <meta name="geo.placename" content="Franklin" />
        <meta name="geo.position" content="41.1220;-74.5804" />
        <meta name="ICBM" content="41.1220, -74.5804" />
        
        {/* Structured Data */}
        <script type="application/ld+json">{JSON.stringify(serviceSchema)}</script>
        <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
        <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
      </Helmet>

      <section className="py-12 sm:py-16 md:py-20 px-4 sm:px-6 lg:px-8 relative overflow-hidden" style={{ background: "var(--gradient-bg)" }}>
        {/* Hidden SEO Image */}
        <img 
          src="https://laminance.com/assets/Images/logo.png"
          alt="Laminance Cabinetry all-inclusive kitchen transformation package - custom cabinets and full renovation services in New Jersey"
          className="hidden"
          loading="eager"
          fetchPriority="high"
          width="1200"
          height="630"
        />

        {/* Background Decorative Elements */}
        <div className="absolute top-0 left-0 w-72 h-72 rounded-full -translate-x-1/2 -translate-y-1/2 opacity-40 blur-3xl" 
          style={{ backgroundColor: "var(--color-primary-100)" }}
          aria-hidden="true"
        ></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 rounded-full translate-x-1/3 translate-y-1/3 opacity-40 blur-3xl" 
          style={{ backgroundColor: "var(--color-amber-50)" }}
          aria-hidden="true"
        ></div>

        <div className="max-w-7xl mx-auto relative z-10">
          {/* Section Header */}
          <div className="text-center mb-8 sm:mb-12">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-6 mx-auto"
              style={{
                background: "var(--bg-primary-10)",
                border: "1px solid var(--border-primary-20)",
              }}
            >
              <MessageSquare size={14} style={{ color: "var(--color-primary-400)" }} />
              <span className="text-sm font-medium" style={{ color: "var(--color-primary-400)" }}>
                Complete Package. Zero Stress.
              </span>
            </div>
            
            <h1 className="bell-mt-primary text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-3 sm:mb-4" style={{ color: "var(--color-primary-500)" }}>
              All-Inclusive Kitchen Transformation
            </h1>
            
            <p className="inter-secondary text-base sm:text-lg max-w-3xl mx-auto px-4" style={{ color: "var(--color-gray-600)" }}>
              Everything you need for a complete kitchen renovation, handled by our expert team from start to finish. 
              Premium custom cabinets, professional installation, and zero stress guaranteed.
            </p>

            {/* Decorative Line */}
            <div className="flex justify-center mt-6" aria-hidden="true">
              <div 
                className="w-24 h-1 rounded-full"
                style={{ background: "var(--gradient-primary)" }}
              ></div>
            </div>
          </div>

          {/* Features Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-8 sm:mb-12 px-2 sm:px-0">
            {features.map((feature, index) => (
              <div
                key={index}
                className="group bg-white p-4 sm:p-6 rounded-xl sm:rounded-2xl border transition-all duration-300 hover:shadow-lg hover:-translate-y-1"
                style={{
                  backgroundColor: "var(--color-white)",
                  borderColor: "var(--border-light)",
                  boxShadow: "var(--shadow-medium)",
                }}
                itemScope
                itemType="https://schema.org/Service"
              >
                {/* Icon and Title - Inline */}
                <div className="flex items-center gap-3 mb-3">
                  {/* Icon Container with Emoji */}
                  <div
                    className="w-12 h-12 sm:w-14 sm:h-14 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform"
                    style={{
                      backgroundColor: "var(--color-primary-500)",
                    }}
                  >
                    <span className="text-2xl sm:text-3xl" style={{ color: "var(--color-white)" }} aria-hidden="true">
                      {feature.icon}
                    </span>
                  </div>

                  {/* Title */}
                  <h2 className="bell-mt-primary text-base sm:text-lg font-semibold" style={{ color: "var(--color-primary-500)" }}>
                    {feature.title}
                  </h2>
                </div>

                {/* Description */}
                <p className="inter-secondary text-xs sm:text-sm leading-relaxed" style={{ color: "var(--color-gray-600)" }}>
                  {feature.description}
                </p>

                {/* Learn More Link */}
                
              </div>
            ))}
          </div>

          {/* Benefits Banner */}
          

          {/* CTA Banner */}
          <div 
            className="rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-10 text-center relative overflow-hidden"
            style={{
              background: "var(--gradient-primary)",
            }}
          >
            {/* Background Decorative Elements */}
            <div 
              className="absolute top-0 left-0 w-32 h-32 sm:w-48 sm:h-48 md:w-64 md:h-64 rounded-full -translate-x-1/2 -translate-y-1/2 opacity-20 blur-3xl" 
              aria-hidden="true"
              style={{ backgroundColor: "var(--color-white)" }}
            ></div>
            <div 
              className="absolute bottom-0 right-0 w-32 h-32 sm:w-48 sm:h-48 md:w-64 md:h-64 rounded-full translate-x-1/2 translate-y-1/2 opacity-20 blur-3xl" 
              aria-hidden="true"
              style={{ backgroundColor: "var(--color-white)" }}
            ></div>

            <div className="relative z-10 max-w-4xl mx-auto">
              <h3 className="bell-mt-primary text-xl sm:text-2xl md:text-3xl font-bold mb-3 sm:mb-4" style={{ color: "var(--color-white)" }}>
                Complete Package. Zero Stress.
              </h3>
              <p className="inter-secondary text-sm sm:text-base md:text-lg mb-4 sm:mb-6 px-2 leading-relaxed" style={{ color: "rgba(255, 255, 255, 0.95)" }}>
                Our all-inclusive service includes premium custom kitchen cabinets, professional countertop installation, 
                custom backsplash design, complete painting services, premium sink and faucet installation, all cabinet hardware, 
                any necessary electrical work, and full labor. We handle everything from demolition to final cleanup.
              </p>
              <div className="flex flex-wrap justify-center gap-2 sm:gap-3 md:gap-4 mb-6 sm:mb-8">
                {["No Hidden Costs", "Single Point of Contact", "Guaranteed Timeline"].map((text, i) => (
                  <div 
                    key={i}
                    className="backdrop-blur-sm px-3 py-1.5 sm:px-4 sm:py-2 rounded-full text-xs sm:text-sm"
                    style={{
                      backgroundColor: "var(--bg-white-10)",
                      border: "1px solid var(--border-white-10)",
                    }}
                  >
                    <span className="font-semibold" style={{ color: "var(--color-white)" }}>{text}</span>
                  </div>
                ))}
              </div>
              
              {/* CTA Button */}
              <Link
                to="/catalog"
                className="inline-flex items-center gap-2 bg-white px-6 sm:px-8 py-2.5 sm:py-3 rounded-full font-semibold text-sm sm:text-base transition-all duration-300 hover:scale-105 hover:shadow-lg"
                style={{ color: "var(--color-primary-500)" }}
                aria-label="Get free design consultation for your all-inclusive kitchen transformation"
              >
                Get Free Design Consultation
                <ArrowRight size={16} />
              </Link>
            </div>
          </div>

          {/* SEO Keyword Section */}
          <div className="mt-8 text-center">
            <p className="inter-secondary text-xs" style={{ color: "var(--color-gray-500)" }}>
              <strong>Popular Kitchen Services:</strong> Custom Kitchen Cabinets | Acrylic Cabinets | Countertop Installation | 
              Backsplash Design | Cabinet Hardware | Kitchen Painting | Sink Installation | Electrical Work | 
              Full Kitchen Remodeling | New Jersey Kitchen Renovation
            </p>
          </div>
        </div>
      </section>
    </>
  )
}

export default Allinclusive